/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Badgeur } from '../models/badgeur';
import { CliproConfig } from '../models/clipro-config';
import { createBadgeur } from '../fn/madic/create-badgeur';
import { CreateBadgeur$Params } from '../fn/madic/create-badgeur';
import { createCliproConfiguration } from '../fn/madic/create-clipro-configuration';
import { CreateCliproConfiguration$Params } from '../fn/madic/create-clipro-configuration';
import { createElysConfiguration } from '../fn/madic/create-elys-configuration';
import { CreateElysConfiguration$Params } from '../fn/madic/create-elys-configuration';
import { ElysConfig } from '../models/elys-config';
import { exportConnectionTagsElysDefinition } from '../fn/madic/export-connection-tags-elys-definition';
import { ExportConnectionTagsElysDefinition$Params } from '../fn/madic/export-connection-tags-elys-definition';
import { getBadgeur } from '../fn/madic/get-badgeur';
import { GetBadgeur$Params } from '../fn/madic/get-badgeur';
import { getBadgeurs } from '../fn/madic/get-badgeurs';
import { GetBadgeurs$Params } from '../fn/madic/get-badgeurs';
import { getCliproConfiguration } from '../fn/madic/get-clipro-configuration';
import { GetCliproConfiguration$Params } from '../fn/madic/get-clipro-configuration';
import { getElysConfiguration } from '../fn/madic/get-elys-configuration';
import { GetElysConfiguration$Params } from '../fn/madic/get-elys-configuration';
import { importConnectionTagsElysDefinition } from '../fn/madic/import-connection-tags-elys-definition';
import { ImportConnectionTagsElysDefinition$Params } from '../fn/madic/import-connection-tags-elys-definition';
import { removeCliproConfiguration } from '../fn/madic/remove-clipro-configuration';
import { RemoveCliproConfiguration$Params } from '../fn/madic/remove-clipro-configuration';
import { removeElysConfiguration } from '../fn/madic/remove-elys-configuration';
import { RemoveElysConfiguration$Params } from '../fn/madic/remove-elys-configuration';
import { updateBadgeur } from '../fn/madic/update-badgeur';
import { UpdateBadgeur$Params } from '../fn/madic/update-badgeur';
import { updateCliproConfiguration } from '../fn/madic/update-clipro-configuration';
import { UpdateCliproConfiguration$Params } from '../fn/madic/update-clipro-configuration';
import { updateElysConfiguration } from '../fn/madic/update-elys-configuration';
import { UpdateElysConfiguration$Params } from '../fn/madic/update-elys-configuration';


/**
 * All about the MADIC connections
 */
@Injectable({ providedIn: 'root' })
export class MadicService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCliproConfiguration()` */
  static readonly GetCliproConfigurationPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/clipro';

  /**
   * Get a CLIPRO configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCliproConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCliproConfiguration$Response(params: GetCliproConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CliproConfig>>> {
    return getCliproConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a CLIPRO configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCliproConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCliproConfiguration(params: GetCliproConfiguration$Params, context?: HttpContext): Observable<Array<CliproConfig>> {
    return this.getCliproConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CliproConfig>>): Array<CliproConfig> => r.body)
    );
  }

  /** Path part for operation `createCliproConfiguration()` */
  static readonly CreateCliproConfigurationPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/clipro';

  /**
   * Create a CLIPRO configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCliproConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCliproConfiguration$Response(params: CreateCliproConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createCliproConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a CLIPRO configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCliproConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCliproConfiguration(params: CreateCliproConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.createCliproConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateCliproConfiguration()` */
  static readonly UpdateCliproConfigurationPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/clipro/{cliproUid}';

  /**
   * update a clipro configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCliproConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCliproConfiguration$Response(params: UpdateCliproConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateCliproConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * update a clipro configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCliproConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCliproConfiguration(params: UpdateCliproConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.updateCliproConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeCliproConfiguration()` */
  static readonly RemoveCliproConfigurationPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/clipro/{cliproUid}';

  /**
   * Remove the station CLIPRO configuration.
   *
   * Remove CLIPRO configuration
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeCliproConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeCliproConfiguration$Response(params: RemoveCliproConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeCliproConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove the station CLIPRO configuration.
   *
   * Remove CLIPRO configuration
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeCliproConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeCliproConfiguration(params: RemoveCliproConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.removeCliproConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getElysConfiguration()` */
  static readonly GetElysConfigurationPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/elys';

  /**
   * Get Elys Config.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getElysConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  getElysConfiguration$Response(params: GetElysConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ElysConfig>>> {
    return getElysConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Elys Config.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getElysConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getElysConfiguration(params: GetElysConfiguration$Params, context?: HttpContext): Observable<Array<ElysConfig>> {
    return this.getElysConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ElysConfig>>): Array<ElysConfig> => r.body)
    );
  }

  /** Path part for operation `createElysConfiguration()` */
  static readonly CreateElysConfigurationPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/elys';

  /**
   * Create a ELYS configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createElysConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createElysConfiguration$Response(params: CreateElysConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createElysConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a ELYS configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createElysConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createElysConfiguration(params: CreateElysConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.createElysConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateElysConfiguration()` */
  static readonly UpdateElysConfigurationPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/elys/{elysUid}';

  /**
   * update a station ELYS configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateElysConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateElysConfiguration$Response(params: UpdateElysConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateElysConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * update a station ELYS configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateElysConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateElysConfiguration(params: UpdateElysConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.updateElysConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeElysConfiguration()` */
  static readonly RemoveElysConfigurationPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/elys/{elysUid}';

  /**
   * Remove the station ELYS configuration.
   *
   * Remove ELYS configuration
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeElysConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeElysConfiguration$Response(params: RemoveElysConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeElysConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove the station ELYS configuration.
   *
   * Remove ELYS configuration
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeElysConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeElysConfiguration(params: RemoveElysConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.removeElysConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportConnectionTagsElysDefinition()` */
  static readonly ExportConnectionTagsElysDefinitionPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/elys/configuration/{elysUid}/export';

  /**
   * Export the MELYSDIC API tags definitions in csv format for a connection.
   *
   * Allows to export the tags definitions, via a XLS File.
   * The connectionUid must be a valid elysUid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportConnectionTagsElysDefinition()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportConnectionTagsElysDefinition$Response(params: ExportConnectionTagsElysDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportConnectionTagsElysDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the MELYSDIC API tags definitions in csv format for a connection.
   *
   * Allows to export the tags definitions, via a XLS File.
   * The connectionUid must be a valid elysUid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportConnectionTagsElysDefinition$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportConnectionTagsElysDefinition(params: ExportConnectionTagsElysDefinition$Params, context?: HttpContext): Observable<Blob> {
    return this.exportConnectionTagsElysDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importConnectionTagsElysDefinition()` */
  static readonly ImportConnectionTagsElysDefinitionPath = '/custom/stations/{uid}/badgeur/{badgeurUid}/elys/configuration/{elysUid}/import';

  /**
   * Import the ELYS API tags definitions for a connection.
   *
   * Allows to import the ELYS API tags definitions, via a XLS File.
   * The connectionUid must be a valid elysUid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importConnectionTagsElysDefinition()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importConnectionTagsElysDefinition$Response(params: ImportConnectionTagsElysDefinition$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importConnectionTagsElysDefinition(this.http, this.rootUrl, params, context);
  }

  /**
   * Import the ELYS API tags definitions for a connection.
   *
   * Allows to import the ELYS API tags definitions, via a XLS File.
   * The connectionUid must be a valid elysUid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importConnectionTagsElysDefinition$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importConnectionTagsElysDefinition(params: ImportConnectionTagsElysDefinition$Params, context?: HttpContext): Observable<void> {
    return this.importConnectionTagsElysDefinition$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getBadgeurs()` */
  static readonly GetBadgeursPath = '/custom/stations/{uid}/badgeur';

  /**
   * Get the list of badgeurs of this station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBadgeurs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBadgeurs$Response(params: GetBadgeurs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Badgeur>>> {
    return getBadgeurs(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the list of badgeurs of this station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBadgeurs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBadgeurs(params: GetBadgeurs$Params, context?: HttpContext): Observable<Array<Badgeur>> {
    return this.getBadgeurs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Badgeur>>): Array<Badgeur> => r.body)
    );
  }

  /** Path part for operation `createBadgeur()` */
  static readonly CreateBadgeurPath = '/custom/stations/{uid}/badgeur';

  /**
   * Create a badgeur.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createBadgeur()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBadgeur$Response(params: CreateBadgeur$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createBadgeur(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a badgeur.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createBadgeur$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBadgeur(params: CreateBadgeur$Params, context?: HttpContext): Observable<void> {
    return this.createBadgeur$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getBadgeur()` */
  static readonly GetBadgeurPath = '/custom/stations/{uid}/badgeur/{badgeurUid}';

  /**
   * Get a, with all information, of this station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBadgeur()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBadgeur$Response(params: GetBadgeur$Params, context?: HttpContext): Observable<StrictHttpResponse<Badgeur>> {
    return getBadgeur(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a, with all information, of this station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBadgeur$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBadgeur(params: GetBadgeur$Params, context?: HttpContext): Observable<Badgeur> {
    return this.getBadgeur$Response(params, context).pipe(
      map((r: StrictHttpResponse<Badgeur>): Badgeur => r.body)
    );
  }

  /** Path part for operation `updateBadgeur()` */
  static readonly UpdateBadgeurPath = '/custom/stations/{uid}/badgeur/{badgeurUid}';

  /**
   * update a badgeur.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateBadgeur()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBadgeur$Response(params: UpdateBadgeur$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateBadgeur(this.http, this.rootUrl, params, context);
  }

  /**
   * update a badgeur.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateBadgeur$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBadgeur(params: UpdateBadgeur$Params, context?: HttpContext): Observable<void> {
    return this.updateBadgeur$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
